/** 与后端 `listLatestCategoryDetails` 等 SQL 中 `categories.type` 取值一致 */
export const KNOWLEDGE_BASE_CATEGORY_TYPE = 'knowledgebase' as const;

/** 侧栏「全部」虚拟节点 id（非数据库分类） */
export const KNOWLEDGE_BASE_SIDEBAR_ALL_ID = '__kb_sidebar_all__' as const;

/** 侧栏「未分类」虚拟节点 id，对应 `knowledgeBases.listUncategorized` */
export const KNOWLEDGE_BASE_SIDEBAR_UNCATEGORIZED_ID = '__kb_sidebar_uncategorized__' as const;
